import { ActionType } from "typesafe-actions";
import * as actions from "./actions";
import { all, call, fork, put, takeEvery } from "redux-saga/effects";
import { callApiPost, callApiGet } from "../../utils/api";
import { message } from "antd";

type AssignStudentAction = ActionType<typeof actions.assignStudentToRoom>;
type UnassignStudentAction = ActionType<typeof actions.unassignStudentFromRoom>;
type GetStudentsInRoomAction = ActionType<typeof actions.getStudentsInRoom>;

function* assignStudentToRoomSaga({ payload }: AssignStudentAction) {
  try {
    const response = yield call(callApiPost, `students/assign-room`, payload);
    yield put(actions.assignStudentToRoomSuccess(response.data));
    message.success("Student assigned to room successfully");
  } catch (error: any) {
    yield put(actions.assignStudentToRoomFailure(error.response.data));
    message.error("Failed to assign student to room");
  }
}

function* unassignStudentFromRoomSaga({ payload }: UnassignStudentAction) {
  try {
    const response = yield call(callApiPost, `students/unassign-room`, payload);
    yield put(actions.unassignStudentFromRoomSuccess(response.data));
    message.success("Student unassigned from room successfully");
  } catch (error: any) {
    yield put(actions.unassignStudentFromRoomFailure(error.response.data));
    message.error("Failed to unassign student from room");
  }
}

function* getStudentsInRoomSaga({ payload }: GetStudentsInRoomAction) {
  try {
    const { roomId, academicYear } = payload;
    const url = academicYear
      ? `students/room/${roomId}?academic_year=${academicYear}`
      : `students/room/${roomId}`;
    const response = yield call(callApiGet, url);
    yield put(actions.getStudentsInRoomSuccess(response.data));
  } catch (error: any) {
    yield put(actions.getStudentsInRoomFailure(error.response.data));
  }
}

function* watchAssignStudent() {
  yield takeEvery(
    actions.StudentRoomAssignmentActionTypes.ASSIGN_STUDENT_REQUEST,
    assignStudentToRoomSaga
  );
}

function* watchUnassignStudent() {
  yield takeEvery(
    actions.StudentRoomAssignmentActionTypes.UNASSIGN_STUDENT_REQUEST,
    unassignStudentFromRoomSaga
  );
}

function* watchGetStudentsInRoom() {
  yield takeEvery(
    actions.StudentRoomAssignmentActionTypes.GET_STUDENTS_IN_ROOM_REQUEST,
    getStudentsInRoomSaga
  );
}

export default function* studentRoomAssignmentSaga() {
  yield all([
    fork(watchAssignStudent),
    fork(watchUnassignStudent),
    fork(watchGetStudentsInRoom),
  ]);
}
